import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper/dist/js/swiper.min.js';

const carousel = {
  init() {


    if (document.querySelector(".swiper-container") !== null) {
      // var initialSlide = document.querySelector('[data-behavior~=initial-slide]').dataset["initialSlide"];


      [].forEach.call(document.querySelectorAll('.swiper-container'), function(el) {

        var dataset = el.dataset['swiperId'];

        var swiper = new Swiper(document.querySelector(`[data-swiper-id~=${dataset}]`), {
          slidesPerView: 2,
          centeredSlides: false,
          loop: false,
          speed: 900,
          spaceBetween: 20,
          breakpoints: {
            // Mobile
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
              initialSlide: 0,
              centeredSlides: false
            }
          },
          pagination: {
            el: `.swiper-pagination-${dataset}`,
            clickable: true,
          }
        });

      })

    }

  }
};

export default carousel;
